<template>
  <section class="custom-refresh">
    <button
      class="btn btn-link custom-action-button"
      type="button"
      title="refresh data"
      @click="refresh"
    >
      <i class="fas fa-sync-alt" :class="{ 'fa-spin': isReloading }"></i>
    </button>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'refresh',
  emits: ['refresh'],
  computed: {
    ...mapGetters('global', ['isReloading']),
  },
  methods: {
    refresh() {
      this.$emit('refresh')
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-action-button:focus {
  box-shadow: none !important;
}
</style>
